import { render, staticRenderFns } from "./siderBar.vue?vue&type=template&id=0d12322c&scoped=true&"
import script from "./siderBar.vue?vue&type=script&lang=js&"
export * from "./siderBar.vue?vue&type=script&lang=js&"
import style0 from "./siderBar.vue?vue&type=style&index=0&id=0d12322c&lang=scss&scoped=true&"
import style1 from "./siderBar.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d12322c",
  null
  
)

export default component.exports